import React from 'react'
import Header from "../components/global/Header"
import Footer from "../components/global/Footer"
import StoreData from "../components/stores/StoreData"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"


function Stores() {

  return (
    <div>
      <Header />
      <div className="container filter">
        <button>Popular <ExpandMoreIcon /></button>
      </div>

      <StoreData />
      <StoreData />
      <StoreData /> 
      <Footer />
    </div>
  )
}

export default Stores;